const peiTransitions = {
  UnSet: 0,
  PostSecondary: 15,
  DepartamentoSalud: 195,
};

export default peiTransitions;
